export const getUnique = (arr: any, comp: any) => {
    return arr
        .map((item: any) => item[comp])
        .map((item: any, i: any, final: any) => final.indexOf(item) === i && i)
        .filter((item: any) => arr[item])
        .map((item: any) => arr[item] as any);
};
